import BaseThrobber from 'features/components/BaseThrobber';
import { getDopplerLoadingDetails } from '../../../../utils/dopplerDisplay.utils.js';

export default function DopplerLoadingOverlay({
  startupReadyFrameCount = 0,
  startupTargetFrameCount = 0,
  showViewLoadingOverlay = false,
  viewLoadingReason = null,
}) {
  const details = getDopplerLoadingDetails({
    showViewLoadingOverlay,
    viewLoadingReason,
    startupReadyFrameCount,
    startupTargetFrameCount,
  });

  return (
    <BaseThrobber
      className="position-absolute top-0 end-0 z-3 m-3 d-inline-flex align-items-center gap-2 px-3 py-2 rounded-3 bg-dark bg-opacity-75 text-white shadow-sm"
      style={{ pointerEvents: 'none' }}
      label={showViewLoadingOverlay ? 'Updating...' : 'Loading...'}
      details={details}
      detailsClassName="small text-white-50"
      detailsStyle={{ fontSize: '0.4375rem', lineHeight: 1.1 }}
    />
  );
}
